export const core_klass = {
  icon: 'mshop-core-icon',
  default_header: 'mshop-default-header',
};

export const default_images = {
  profile: '//s3.marpple.co/files/u_2308668/2023/7/original/971cdb97abebab382b709220a5540a78580a754d1.png',
};
